import React from 'react';

import V2PostflopPanel from './V2PostflopPanel';
import { FAQ_PREFLOP_PREVIEW, FAQ_STATS_PREVIEW } from '../data/faqStatsPreview';

const V2FAQStatsPreview: React.FC = () => (
  <div className="faq-stats-preview" aria-label="Пример панели статистики">
    <div className="faq-stats-preview__summary">
      <section className="stats-row stats-row--primary" aria-label="Preflop KPI">
        <div className="stat-cell">
          <p className="stat-cell__label">VPIP / PFR</p>
          <p className="stat-cell__value stat-cell__value--ratio">
            {FAQ_STATS_PREVIEW.vpip ?? '—'}
            <span className="kpi-ratio-sep" aria-hidden="true">
              /
            </span>
            {FAQ_STATS_PREVIEW.pfr ?? '—'}
          </p>
        </div>
      </section>
      <section className="stats-row stats-row--preflop" aria-label="Preflop">
        {FAQ_PREFLOP_PREVIEW.map(([name, value]) => (
          <div className="stat-cell" key={name}>
            <p className="stat-cell__label">{name}</p>
            <p className="stat-cell__value">{value}</p>
          </div>
        ))}
      </section>
    </div>
    <V2PostflopPanel stats={FAQ_STATS_PREVIEW} />
  </div>
);

export default V2FAQStatsPreview;
